module.exports = __webpack_public_path__ + "static/media/godiva.976ebf6c.png";